import { Row } from 'react-bootstrap';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { User } from '../../../../../model/user/User';
import Tooltip from '@mui/material/Tooltip';
import { hasAccessRights, openCalendlyPopup } from '../../../../../shared/functions/Functions';
import { useNavigate, useParams } from 'react-router-dom';
import { IParams } from '../../../../../model/shared/IParams';
import { InternalRoutes } from '../../../../../enum/InternalRoutes';
import { CampaignManagementUser } from './CampaignManagementUser';
import { AccessRightEnum } from '../../../../../enum/AccessRightEnum';

interface ICampaignSupervisorCardProps {
    supervisors: User[];
}

export function CampaignSupervisorCard({ supervisors }: ICampaignSupervisorCardProps) {
    const { t } = useTranslation();
    const { id } = useParams<keyof IParams>();
    const navigate = useNavigate();

    const openMessageTab = () => {
        navigate(`${InternalRoutes.BRAND_CAMPAIGN_MESSAGES}/${id}`);
    };

    return (
        <div>
            <h6
                className="textHover cursor-pointer mb-3"
                onClick={() => !!supervisors[0]?.supervisorLink && openCalendlyPopup(supervisors[0]?.supervisorLink)}
            >
                <img
                    alt="Customer success manager icon"
                    className="mr-2"
                    width="20"
                    height="20"
                    src="/icons/logos/logoSmall.svg"
                />
                {t('brand.campaign.dashboard.customer_success_manager')}
            </h6>
            {(supervisors?.length ?? 0) > 0 && (
                <Row className="align-items-center mt-2" style={{ gap: 20 }}>
                    {supervisors?.slice(0, 2)?.map(userData => {
                        return (
                            <CampaignManagementUser
                                user={{ ...userData, brandCompany: userData }}
                                brandCompany={undefined}
                                key={userData?.id}
                                showCrown={false}
                                hidePosition={true}
                            />
                        );
                    })}
                    {(supervisors?.length ?? 0) > 2 && (
                        <div className="col-auto">
                            <Tooltip
                                id="white-tooltip"
                                title={
                                    <>
                                        {supervisors?.slice(2)?.map(userData => (
                                            <div className="text-dark p-1" key={userData?.id}>
                                                <CampaignManagementUser
                                                    user={{ ...userData, brandCompany: userData }}
                                                    brandCompany={undefined}
                                                    key={userData?.id}
                                                    classParent="px-0"
                                                />
                                            </div>
                                        ))}
                                    </>
                                }
                                placement="left"
                                className="cursor-pointer"
                            >
                                <span
                                    className="icon-round bg-white text-primary shadow font-weight-semi-bold min-width-max-content"
                                    style={{ width: 33 }}
                                >
                                    + {(supervisors?.length ?? 0) - 2}
                                </span>
                            </Tooltip>
                        </div>
                    )}
                </Row>
            )}
            <div className="d-flex justify-content-between">
                <a href={`mailto:${supervisors[0]?.email}`} className="mb-0 text-secondary text-underline">
                    {t('general.button.contact')}
                </a>
                <div>
                    {supervisors[0]?.supervisorLink && (
                        <span
                            className="cursor-pointer mr-3 text-uppercase text-primary"
                            onClick={() => openCalendlyPopup(supervisors[0]?.supervisorLink)}
                        >
                            {t('brand.campaign.dashboard.book_a_meeting')}
                        </span>
                    )}
                    {!hasAccessRights(AccessRightEnum.CAN_VIEW_CONTRACTS) && (
                        <span className="cursor-pointer text-uppercase text-primary" onClick={openMessageTab}>
                            {t('brand.campaign.dashboard.need_assistance')}
                        </span>
                    )}
                </div>
            </div>
        </div>
    );
}
